import { objectToQueryString } from '@/common/js/utils';
import { ICommonRes } from '@/interface';
import { httpManager, stmHttpClient } from '@/plugins/HttpManager';
import { IGetFeatureAvailabilityArgs, IGetFeatureAvailabilityResponse, IGetFeedBackOptionsArgs, IGetFeedBackOptionsResponse, IModifyDeviceBodyArgs, IQueryVideoArgs, IReportAIUsageFeedbackArgs, ISearchVideoEventsResponse } from '@reolink-cloud/interface';

export const searchEvent = async ( args: IQueryVideoArgs ): Promise<ISearchVideoEventsResponse> => {

    const res = await stmHttpClient.post<ISearchVideoEventsResponse>( 'cloud/ai/video/query', args, { encryptRequestBody: false });

    return res.data;

};

export const modifyDeviceAiConfig = async ( args: IModifyDeviceBodyArgs ): Promise<void> => {

    await httpManager.patch( '/cloud/subscriptions/devices', args );

};

export const getSearchRecommendations = async( lang?: string ): Promise<string[]> => {

    const { data } = await httpManager.get<ICommonRes<string>>( `/cloud/ai/search/recommendation?language=${lang ?? 'en'}` );

    return data.items;

};

export const getFeedbackOptions = async( args: IGetFeedBackOptionsArgs ): Promise<IGetFeedBackOptionsResponse> => {

    const { data } = await httpManager.get<IGetFeedBackOptionsResponse>( `/cloud/ai/feedback/option${objectToQueryString( args )}` );

    return data;

};

export const reportAiUsageFeedback = async( args: IReportAIUsageFeedbackArgs ): Promise<void> => {

    await httpManager.post( '/cloud/ai/feedback', args );

};

export const getAiAvailability = async ( args: IGetFeatureAvailabilityArgs ): Promise<IGetFeatureAvailabilityResponse> => {

    const { data } = await httpManager.get<IGetFeatureAvailabilityResponse>( `/cloud/subscriptions/ai/availability${objectToQueryString( args )}` );
    return data;

};
